/* eslint-disable no-nested-ternary */
import { isBoolean } from 'lodash';
import React from 'react';
import { StyleSheet, View, ViewProps } from 'react-native';

interface Props extends ViewProps {
  reversed?: boolean;
  flex?: number | boolean;
  backgroundColor?: string;
  padding?: number;
  paddingLeft?: number;
  paddingRight?: number;
  paddingTop?: number;
  paddingBottom?: number;
  paddingVertical?: number;
  paddingHorizontal?: number;
  middle?: boolean;
  center?: boolean;
  margin?: number;
  marginLeft?: number;
  marginRight?: number;
  marginVertical?: number;
  marginHorizontal?: number;
  marginTop?: number;
  marginBottom?: number;
  borderRadius?: any;
  height?: any;
  width?: any;
}
export const Row = React.forwardRef(
  (
    {
      reversed,
      style,
      flex,
      middle,
      center,
      backgroundColor,
      height,
      width,
      padding,
      paddingTop,
      paddingBottom,
      paddingLeft,
      paddingRight,
      paddingHorizontal,
      paddingVertical,
      margin,
      marginVertical,
      marginLeft,
      marginRight,
      marginHorizontal,
      marginTop,
      marginBottom,
      borderRadius,
      ...props
    }: Props,
    ref: any,
  ) => {
    const flexStyle = flex ? (isBoolean(flex) ? { flex: 1 } : { flex }) : null;

    return (
      <View
        ref={ref}
        style={[
          styles.wrapper,
          { flexDirection: reversed ? 'row-reverse' : 'row' },
          flexStyle,
          backgroundColor ? { backgroundColor } : null,
          {
            height,
            width,
            padding,
            paddingTop,
            paddingBottom,
            paddingLeft,
            paddingRight,
            paddingHorizontal,
            paddingVertical,
            margin,
            marginHorizontal,
            marginLeft,
            marginRight,
            marginVertical,
            marginTop,
            marginBottom,
            borderRadius,
          },
          middle && { alignItems: 'center' },
          center && { alignItems: 'center', justifyContent: 'center' },
          style,
        ]}
        {...props}>
        {props.children}
      </View>
    );
  },
);

const styles = StyleSheet.create({
  wrapper: {},
});
